<div class="modal-header">
  <h4 class="modal-title">
    {{ title }}
    {{ 'priceSupportAgreement.distributorEndUserAccount' | cxTranslate }}
  </h4>

  <button type="button" class="close closeModal" aria-label="Close" (click)="modal.close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <input
    class="form-control ng-valid noOutline"
    placeholder="Enter Account #"
    ngModel
    #input="ngModel"
    [(ngModel)]="accountNumber"
    [disabled]="disableOnSubmit"
  />
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-sm btn-secondary" [disabled]="disableOnSubmit" (click)="modal.close()">
    {{ 'shared.close' | cxTranslate }}
  </button>
  <div>
    <app-custom-button
      title="Submit"
      styleClass="btn-sm"
      [showSpinner]="showLoader"
      [disableBtn]="disableOnInvalidAccount"
      (clicked)="updateAccountNumber(input.value)"
    ></app-custom-button>
  </div>
</div>
